import React, {useState} from 'react'
import {Button, Row, Col, Form} from 'react-bootstrap';

export default function AddComment(props) {
  const [description, setDescription] = useState('');

  const handleSubmit = () => {
    props.createNewComment(description);
    setDescription('');
  }

  return (
    <div className="write-comment mt-3">
      <p className="modal-mini-heading"><strong>Add a Comment:</strong></p>
      <Row noGutters className="mb-4">
        <Col lg={10} md={10} sm={12}><Form.Control className="comment-input" as="textarea" rows={1} placeholder="Also have this problem? Have a similar suggestion?" onChange={(e) => setDescription(e.target.value)} value={description}/></Col>
        <Col lg={2} md={2} sm={12}><Button className="w-100" variant="outline-success" onClick={handleSubmit}>Submit</Button></Col>
      </Row>
    </div>
  )
}
